import ExpandableListComponent from '@intercom/embercom-composer/components/expandable-list';
export default ExpandableListComponent;
